export default __webpack_public_path__ + "static/media/_IMG5991.dc3e3cf1.jpg";